import { Worker } from "@react-pdf-viewer/core";
import { PropsWithChildren } from "react";

const WithPdfJsWorker: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@6.1.200/build/pdf.worker.min.mjs">
      {children}
    </Worker>
  );
};

export default WithPdfJsWorker;
